module.exports = __webpack_public_path__ + "img/1.f7d84b2f.png";